import React from "react";
import { InfoTitle, InfoValue } from "./styles";
import { Grid, GridProps } from "@material-ui/core";
import EasyTechIcons, { IconTypes } from "components/Icons/EasyTechIcons";

interface DialogInfoFieldProps extends GridProps {
  title: string;
  value: string | number | JSX.Element;
  icon?: IconTypes;
}

export default function DialogInfoField({
  title = "",
  value,
  icon,
  ...rest
}: DialogInfoFieldProps) {
  return (
    <Grid {...rest}>
      <InfoTitle>
        {title}
        {icon && <EasyTechIcons name={icon} />}
      </InfoTitle>
      <InfoValue>{value}</InfoValue>
    </Grid>
  );
}
